import React from "react";
import { Select } from "antd";

import styles from "./style.scss";
import {
  parseFormControlValue,
  checkEmptyObject,
  showDropdownSearch,
  getWindowWidth
} from "../../../services/utils";
import { InputType, LocalStorageKey } from "../../../models/enums";
import { isSearchMobile, localStorage, matchesSearchText } from "../../../services";
import MobileDropdownSelect from "./MobileDropdownSelect";

const DropdownSelect = props => {
  const {
    options,
    placeholder = "Odaberite",
    title = "",
    isRequired = false,
    valueType = "",
    hasAnyValue = false,
    anyTitle = "Poništi",
    className = "",
    style = {},
    onChange,
    isDisabled = false,
    tyres = false,
    showPlaceholder = false,
    field,
    value: propValue,
    getPopupContainer,
    showPopular = false,
    dataSource
  } = props;


  const getValue = () => {
    if (checkEmptyObject(propValue)) {
      return handleBooleanValue(propValue[field]);
    }

    return undefined;
  };

  const handleChange = option => {
    let value = option;

    if (value !== "") {
      if (valueType === InputType.boolean) {
        value = Boolean(value);
      }
    } else {
      onChange({ [field]: undefined });
      return;
    }

    if (tyres) {
      onChange({ ...propValue, ...parseFormControlValue([field], [value]) });
    } else {
      onChange(parseFormControlValue([field], [value]));
    }
  };

  const handleBooleanValue = value => {
    if (valueType === InputType.boolean) {
      return value ? 1 : 0;
    }

    return value;
  };

  const handleSearch = (input, option) => {
    const text = option && option.props && option.props.children;
    return typeof text === "string" && matchesSearchText(input, text);
  };

  const showSearch = () => {
    const anyOptionValue = hasAnyValue ? 1 : 0;
    const optionsCount = options.length + anyOptionValue;

    return showDropdownSearch(optionsCount);
  };

  const allOptions = options.map(o => ({
    ...o,
    value: handleBooleanValue(o.value)
  }));

  const value = getValue();

  if (hasAnyValue && value) {
    allOptions.unshift({
      title: anyTitle,
      value: "",
      style: {
        borderBottom: "1px solid #e8e8e8"
      }
    });
  }

  // Check if options have popular grouping
  const hasPopularOptions = showPopular && allOptions.some(o => o.popular);
  const popularOptions = hasPopularOptions ? allOptions.filter(o => o.popular) : [];
  const otherOptions = hasPopularOptions ? allOptions.filter(o => !o.popular) : [];

  const renderOptions = (opts) =>
    opts.map((option, index) => (
      <Select.Option
        key={option.value || index}
        value={option.value}
        style={option.style || {}}
      >
        {option.title}
      </Select.Option>
    ));

  if (isSearchMobile(getWindowWidth())) {
    return (
      <span style={style}>
        {!showPlaceholder && (
          <span
            className={`control-title ${isRequired ? "required" : ""} ${
              styles.label
            }`}
          >
            {title}
          </span>
        )}
        <MobileDropdownSelect
          options={allOptions}
          value={value}
          valueType={valueType}
          placeholder={showPlaceholder ? title : placeholder}
          isDisabled={isDisabled}
          onChange={handleChange}
          title={title}
          showPopular={showPopular}
          dataSource={dataSource}
        />
      </span>
    );
  }

  return (
    <span className={className} style={style}>
      {showPlaceholder ? null : (
        <span className={`control-title ${isRequired ? "required" : ""}`}>
          {title}
        </span>
      )}
      <Select
        value={value}
        onChange={handleChange}
        placeholder={showPlaceholder ? title : placeholder}
        disabled={isDisabled}
        showSearch={showSearch()}
        optionFilterProp="children"
        filterOption={handleSearch}
        className={isDisabled ? styles.disabledSelect : ""}
        notFoundContent={"Nema rezultata"}
        getPopupContainer={getPopupContainer}
      >
        {hasPopularOptions ? [
          <Select.OptGroup key="popular" label={dataSource === "location" ? "Top lokacije" : "Top marke"}>
            {renderOptions(popularOptions)}
          </Select.OptGroup>,
          <Select.OptGroup key="other" label={dataSource === "location" ? "Ostale lokacije" : "Ostale marke"}>
            {renderOptions(otherOptions)}
          </Select.OptGroup>
        ] : renderOptions(allOptions)}
      </Select>
    </span>
  );
};

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/FormControls/DropdownSelect/DropdownSelect.tsx